if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility:false
    });

    if(document.getElementById('menusPopup')){
        
        setTimeout(function(){
            document.getElementById('menusPopup').classList.add('open')
        },400);

        document.getElementById('menusClose').addEventListener('click', function(e){
            e.preventDefault();
            document.getElementById('menusPopup').classList.remove('open');
        });
    }
    $('img').each(function() {

        var height = $(this).height();
        var width = $(this).width();

        $(this).attr("width",width);
        $(this).attr("height",height);
    });

    const secondMenu = document.getElementById("second-menu"),
          thirdMenu = document.getElementById("third-menu");

    if (secondMenu || thirdMenu) {
        function calcOffsetTop() {
            document.documentElement.style.cssText = `
                --header-offset: ${this.offsetTop + this.clientHeight}px;
                --submenu-offset: ${secondMenu.clientHeight}px;
            `;
        }

        const observer = new MutationObserver(records => {
            for (const record of records) {
                if (record.type == "attributes") {
                    record.target.addEventListener("transitionend", calcOffsetTop, { once: true });
                    observer.disconnect();
                }
            }
        });
        
        observer.observe( document.getElementById("header") || document.querySelector('body > header') , { attributes: true } );
    }

    //for Menus
	document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menu__unitmenu').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});

    //for Menus
	document.querySelectorAll('.menu-restaurant__tabs option').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.menu-restaurant__tabs option').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menu__unitmenu').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});

	let selectMenu = document.querySelector('.menu-restaurant__tabs')
	selectMenu && selectMenu.addEventListener('change', (e) => {
		let menuId = selectMenu.value;

		let menu_container = document.querySelectorAll('.menu__unitmenu');
		menu_container = [...menu_container];

		menu_container.forEach( (contendor) => {
			if (contendor.dataset.tag == menuId) {
				contendor.classList.add('active');
			}else{
				contendor.classList.remove('active');
			}
		})

	})
    /** Function limit specific textarea form */
const interval = setInterval(() => {
  const textarea = document.getElementById("id_7_4650");
  if (textarea) {
    textarea.addEventListener("input", function () {
      if (this.value.length > 50) {
        this.value = this.value.slice(0, 50);
      }
    });
    clearInterval(interval);
  }
}, 500);


    /** End function  */

}());